module.exports = __webpack_public_path__ + "static/media/pamain.28d4e25e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pamain.woff
// module id = ./src/assets/fonts/pamain.woff
// module chunks = 6